import React, { useCallback, useState } from "react";
import { AlertLineReportDTO } from "../../../../models/alert-line-report/alert-line-report-dto";
import { useTranslation } from "react-i18next";
import { AlertLineReportApiService } from "../../../../services/alert-line/alert-line-report-api.service";
import CheckPreviousAlertLineReport from "./CheckPreviousAlertLineReport/CheckPreviousAlertLineReport";
import PreviousAlertLineReportContent from "./PreviousAlertLineReportContent/PreviousAlertLineReportContent";
import { AlertLineURLDTO } from "../../../../models/alert-line-url/alert-line-url-dto";
import { AvailableLanguageRef } from "../../../../models/available-language";

interface Props {
  alertLineURL: AlertLineURLDTO;
  updateParentWithPreviousreport: (previousReport: AlertLineReportDTO) => void;
  handleSetLanguage: (language: AvailableLanguageRef) => void;
}
interface State {
  open: boolean;
  loading: boolean;
  error: string;
  alertLineReport: AlertLineReportDTO | null;
  reportId: string;
}

const PreviousAlertLineReport = ({ alertLineURL, updateParentWithPreviousreport, handleSetLanguage }: Props) => {
  const [state, setState] = useState<State>({
    open: false,
    loading: false,
    error: "",
    alertLineReport: null,
    reportId: "",
  });

  return (
    <>
      {state.alertLineReport ? (
        <PreviousAlertLineReportContent
          alertLineReport={state.alertLineReport}
          handleSetLanguage={handleSetLanguage}
        />
      ) : (
        <CheckPreviousAlertLineReport
          alertLineURL={alertLineURL}
          handlePreviousReport={(report: AlertLineReportDTO) => {
            setState((state) => ({ ...state, alertLineReport: report ?? null }));
            updateParentWithPreviousreport(report);
          }}
        />
      )}
    </>
  );
};
export default PreviousAlertLineReport;
